import { archiveMimeTypes, AudioMimeTypes, CodeMimeTypes, ExcelMimeTypes, ImageMimeTypes, MarkdownMimeTypes, MimeType, OfdMimeTypes, PowerPointMimeTypes, TextMimeTypes, VideoMimeTypes, WordMimeTypes } from '@tencent/docs-mime-types';
import { faviconUrl, iconPng3xUrl, iconPngUrl, iconUrl, privateTDocsSvgUrl, privateTDocsUrl, sharePlaceholderUrl, structuredCoverUrl, structuredMessageUrl } from "./icons";
export { DocType, MimeType, PadType } from '@tencent/docs-mime-types';
export var matchExtensionNameToMimetype = [{
  reg: /doc|dot|wps|wpt|docx|dotx|docm|dotm/,
  result: MimeType.Word
}, {
  reg: /xls|xlt|xlsx|xltx|csv|xlsb|xlsm|xltm|et|ett|ets/,
  result: MimeType.Excel
}, {
  reg: /pptx|ppt|pot|potx|pps|ppsx|dps|dpt|pptm|potm|ppsm/,
  result: MimeType.Powerpoint
}, {
  reg: /lrc|asp|bat|bas|prg|cmd|rtf|txt|log|xml|htm|html/,
  result: MimeType.Txt
}, {
  reg: /^(raw|bmp|pcx|tiff|gif|exif|jpeg|jpg|fpx|svg|psd|cdr|pcd|dxf|ufo|eps|png|wmf|webp|tga)/,
  result: MimeType.Image
}, {
  reg: /zip|7z|rar/,
  result: MimeType.Zip
}, {
  // 因为video格式里也有mpeg，为避免混乱，把mpeg格式从audio里移除
  reg: /^(mp3|acc|flac|amr|m4a|m4b|wma|wav|cd|wave|aiff|midi|ra|vqf|ogg|ape|weba|aac|flac|mpeg-4|realaudio)/,
  result: MimeType.Audio
}, {
  reg: /^(mp4|3gp|asf|avi|dv|flv|f4v|m3u8|mkv|qt|mov|mpg|mpeg|mts|vob|wmv|rm|m4v|asx|dat|rmvb)/,
  result: MimeType.Video
}, {
  reg: /^(c|cpp|h|asm|s|java|js|jsx|ts|tsx|go|py|md|sh|asp|jsp|php|sql|json|kt|yaml|rust|rs|swift|dart|cs)/,
  result: MimeType.Code
}, {
  reg: /pdf/,
  result: MimeType.Pdf
}, {
  reg: /vsdx|vsd/,
  result: MimeType.Visio
}, {
  reg: /pos|xmind/,
  result: MimeType.XMind
}, {
  reg: /ofd/,
  result: MimeType.Ofd
}];

/**
 * 对 mimetype 部分匹配的规则
 */
export var matchMimeTypeToUrl = [{
  mimeTypes: MarkdownMimeTypes,
  result: iconUrl['application-vnd.tdocs-apps.markdown']
}, {
  mimeTypes: WordMimeTypes,
  result: iconUrl['application-vnd.ms-word']
}, {
  mimeTypes: ExcelMimeTypes,
  result: iconUrl['application-vnd.ms-excel']
}, {
  mimeTypes: PowerPointMimeTypes,
  result: iconUrl['application-vnd.ms-powerpoint']
}, {
  mimeTypes: CodeMimeTypes,
  result: iconUrl.code
}, {
  mimeTypes: ImageMimeTypes,
  result: iconUrl.image
}, {
  mimeTypes: AudioMimeTypes,
  result: iconUrl.audio
}, {
  mimeTypes: VideoMimeTypes,
  result: iconUrl.video
}, {
  mimeTypes: TextMimeTypes,
  result: iconUrl.text
}, {
  mimeTypes: [MimeType.Folder],
  result: iconUrl['application-vnd.tdocs-apps.folder']
}, {
  mimeTypes: archiveMimeTypes,
  result: iconUrl['application-zip']
}, {
  mimeTypes: [MimeType.CollaborationSpaceRoot],
  result: privateTDocsSvgUrl['application-vnd.tdocs-apps.collaboration-space-root']
}, {
  mimeTypes: OfdMimeTypes,
  result: iconUrl['application-ofd']
}];

/**
 * 小程序结构化消息对 mimetype 部分匹配的规则（对类型的兜底图片）
 */
export var matchMimeTypeToStructuredMessageUrl = [{
  mimeTypes: MarkdownMimeTypes,
  result: structuredCoverUrl['application-vnd.tdocs-apps.markdown']
}, {
  mimeTypes: ImageMimeTypes,
  result: structuredMessageUrl.image
}, {
  mimeTypes: AudioMimeTypes,
  result: structuredMessageUrl.audio
}, {
  mimeTypes: VideoMimeTypes,
  result: structuredMessageUrl.video
}, {
  mimeTypes: TextMimeTypes,
  result: structuredMessageUrl.text
}, {
  mimeTypes: [MimeType.Folder],
  result: structuredMessageUrl['application-vnd.tdocs-apps.folder']
}, {
  mimeTypes: WordMimeTypes,
  result: structuredMessageUrl['application-vnd.ms-word']
}, {
  mimeTypes: ExcelMimeTypes,
  result: structuredMessageUrl['application-vnd.ms-excel']
}, {
  mimeTypes: PowerPointMimeTypes,
  result: structuredMessageUrl['application-vnd.ms-powerpoint']
}, {
  mimeTypes: OfdMimeTypes,
  result: structuredMessageUrl['application_ofd']
}];

/**
 * 小程序结构化封面对 mimetype 部分匹配的规则
 */
export var matchMimeTypeToStructuredCoverUrl = [{
  mimeTypes: MarkdownMimeTypes,
  result: structuredCoverUrl['application-vnd.tdocs-apps.markdown']
}, {
  mimeTypes: ImageMimeTypes,
  result: structuredCoverUrl.image
}, {
  mimeTypes: AudioMimeTypes,
  result: structuredCoverUrl.audio
}, {
  mimeTypes: VideoMimeTypes,
  result: structuredCoverUrl.video
}, {
  mimeTypes: TextMimeTypes,
  result: structuredCoverUrl.text
}, {
  mimeTypes: [MimeType.Folder],
  result: structuredCoverUrl['application-vnd.tdocs-apps.folder']
}, {
  mimeTypes: WordMimeTypes,
  result: structuredCoverUrl['application-vnd.ms-word']
}, {
  mimeTypes: ExcelMimeTypes,
  result: structuredCoverUrl['application-vnd.ms-excel']
}, {
  mimeTypes: PowerPointMimeTypes,
  result: structuredCoverUrl['application-vnd.ms-powerpoint']
}, {
  mimeTypes: OfdMimeTypes,
  result: structuredCoverUrl['application_ofd']
}];

/**
 * 小程序结构化封面对 mimetype 部分匹配的规则
 */
export var matchMimeTypeToSharePlaceholderUrl = [{
  mimeTypes: MarkdownMimeTypes,
  result: sharePlaceholderUrl['application-vnd.tdocs-apps.markdown']
}, {
  reg: /addon/i,
  result: sharePlaceholderUrl['application-vnd.tdocs-apps-addon']
}, {
  mimeTypes: ImageMimeTypes,
  result: sharePlaceholderUrl.image
}, {
  mimeTypes: AudioMimeTypes,
  result: sharePlaceholderUrl.audio
}, {
  mimeTypes: VideoMimeTypes,
  result: sharePlaceholderUrl.video
}, {
  mimeTypes: TextMimeTypes,
  result: sharePlaceholderUrl['application-vnd.ms-word']
}, {
  mimeTypes: WordMimeTypes,
  result: sharePlaceholderUrl['application-vnd.ms-word']
}, {
  mimeTypes: ExcelMimeTypes,
  result: sharePlaceholderUrl['application-vnd.ms-excel']
}, {
  mimeTypes: PowerPointMimeTypes,
  result: sharePlaceholderUrl['application-vnd.ms-powerpoint']
}, {
  mimeTypes: OfdMimeTypes,
  result: sharePlaceholderUrl['application-pdf'] // 与pdf用同一个图片
}];

/**
 * 对 mimetype 部分匹配的规则（对类型的兜底图片）
 * 返回 png 图标路径
 */
export var matchMimeTypeToPngUrl = [{
  mimeTypes: MarkdownMimeTypes,
  result: iconPngUrl['application-vnd.tdocs-apps.markdown']
}, {
  mimeTypes: ImageMimeTypes,
  result: iconPngUrl.image
}, {
  mimeTypes: AudioMimeTypes,
  result: iconPngUrl.audio
}, {
  mimeTypes: VideoMimeTypes,
  result: iconPngUrl.video
}, {
  mimeTypes: TextMimeTypes,
  result: iconPngUrl.text
}, {
  mimeTypes: CodeMimeTypes,
  result: iconPngUrl.code
}, {
  mimeTypes: [MimeType.Folder],
  result: iconPngUrl['application-vnd.tdocs-apps.folder']
}, {
  mimeTypes: WordMimeTypes,
  result: iconPngUrl['application-vnd.ms-word']
}, {
  mimeTypes: ExcelMimeTypes,
  result: iconPngUrl['application-vnd.ms-excel']
}, {
  mimeTypes: PowerPointMimeTypes,
  result: iconPngUrl['application-vnd.ms-powerpoint']
}, {
  mimeTypes: archiveMimeTypes,
  result: iconPngUrl['application-zip']
},
// FIXME: 暂时先放在这里，先让本地调试icon不空白
{
  mimeTypes: [MimeType.CollaborationSpaceRoot],
  result: privateTDocsUrl['application-vnd.tdocs-apps.collaboration-space-root']
}, {
  mimeTypes: OfdMimeTypes,
  result: iconPngUrl['application-ofd']
}];

/**
 * 对 mimetype 部分匹配的规则（对类型的兜底图片）
 * 返回 png 图标路径
 */
export var matchMimeTypeTo3xPngUrl = [{
  mimeTypes: MarkdownMimeTypes,
  result: iconPng3xUrl['application-vnd.tdocs-apps.markdown']
}, {
  mimeTypes: ImageMimeTypes,
  result: iconPng3xUrl.image
}, {
  mimeTypes: AudioMimeTypes,
  result: iconPng3xUrl.audio
}, {
  mimeTypes: VideoMimeTypes,
  result: iconPng3xUrl.video
}, {
  mimeTypes: TextMimeTypes,
  result: iconPng3xUrl.text
}, {
  mimeTypes: CodeMimeTypes,
  result: iconPng3xUrl.code
}, {
  mimeTypes: [MimeType.Folder],
  result: iconPng3xUrl['application-vnd.tdocs-apps.folder']
}, {
  mimeTypes: WordMimeTypes,
  result: iconPng3xUrl['application-vnd.ms-word']
}, {
  mimeTypes: ExcelMimeTypes,
  result: iconPng3xUrl['application-vnd.ms-excel']
}, {
  mimeTypes: PowerPointMimeTypes,
  result: iconPng3xUrl['application-vnd.ms-powerpoint']
}, {
  mimeTypes: archiveMimeTypes,
  result: iconPng3xUrl['application-zip']
},
// FIXME: 暂时先放在这里，先让本地调试icon不空白
{
  mimeTypes: [MimeType.CollaborationSpaceRoot],
  result: privateTDocsUrl['application-vnd.tdocs-apps.collaboration-space-root']
}, {
  mimeTypes: OfdMimeTypes,
  result: iconPng3xUrl['application-ofd']
}];
export var matchMimeTypeToFavicon = [{
  mimeTypes: MarkdownMimeTypes,
  result: faviconUrl['application-vnd.tdocs-apps.markdown']
}, {
  mimeTypes: ImageMimeTypes,
  result: faviconUrl.image
}, {
  mimeTypes: AudioMimeTypes,
  result: faviconUrl.audio
}, {
  mimeTypes: VideoMimeTypes,
  result: faviconUrl.video
}, {
  mimeTypes: TextMimeTypes,
  result: faviconUrl.text
}, {
  mimeTypes: CodeMimeTypes,
  result: faviconUrl.code
}, {
  mimeTypes: WordMimeTypes,
  result: faviconUrl['application-vnd.ms-word']
}, {
  mimeTypes: ExcelMimeTypes,
  result: faviconUrl['application-vnd.ms-excel']
}, {
  mimeTypes: PowerPointMimeTypes,
  result: faviconUrl['application-vnd.ms-powerpoint']
}, {
  mimeTypes: [MimeType.Doc],
  result: faviconUrl['application-vnd.tdocs-apps.doc']
}, {
  mimeTypes: [MimeType.Sheet],
  result: faviconUrl['application-vnd.tdocs-apps.sheet']
}, {
  mimeTypes: [MimeType.Slide],
  result: faviconUrl['application-vnd.tdocs-apps.slide']
}, {
  mimeTypes: [MimeType.Pdf],
  result: faviconUrl['application-pdf']
}, {
  mimeTypes: [MimeType.Mind],
  result: faviconUrl['application-vnd.tdocs-apps.mind']
}, {
  mimeTypes: [MimeType.FlowChart],
  result: faviconUrl['application-vnd.tdocs-apps.flowchart']
}, {
  mimeTypes: archiveMimeTypes,
  result: faviconUrl['application-zip']
}, {
  mimeTypes: OfdMimeTypes,
  result: faviconUrl['application-ofd']
}];

/** 一般场景的兜底文件icon */
export var defaultFileIconUrl = iconUrl['application-vnd.tdocs-apps.default'];

/** 一般场景的兜底文件icon（png格式） */
export var defaultFileIconPngUrl = iconPngUrl['application-vnd.tdocs-apps.default'];

/** 一般场景的兜底文件夹icon */
export var defaultFolderIconUrl = iconUrl['application-vnd.tdocs-apps.folder'];

/** 小程序分享的卡片态（结构化消息）场景下文件兜底icon */
export var defaultFileMiniProgramStructuredMessageUrl = structuredMessageUrl['application-vnd.tdocs-apps.default'];

/** 小程序分享确认界面（结构化封面）场景下文件的兜底icon */
export var defaultFileMiniProgramStructuredCoverUrl = structuredCoverUrl['application-vnd.tdocs-apps.default'];

/** 小程序分享非owner（分享占位符）场景下文件兜底icon */
export var defaultFileMiniProgramSharePlaceholderUrl = sharePlaceholderUrl['application-vnd.tdocs-apps.default'];

/** 小程序分享非owner（分享占位符）场景下第三方插件icon */
export var addonMiniProgramSharePlaceholderUrl = sharePlaceholderUrl['application-vnd.tdocs-apps-addon'];
export var defaultFaviconUrl = faviconUrl['application-vnd.tdocs-apps.default'];

/** cdn 域名，主要用于拼接 URL 场景 */
/* eslint-disable @tencent/tdoc-standalone/no-use-uri-like-literal */
export var cdnDomain = 'https://docs.gtimg.com/docs-design-resources/document-management/';

/** 一般icon场景的路径 */
export var fileIconSvgPath = 'tencent-docs/svg/';
export var fileIconPngPath = 'tencent-docs/png-200px/';

/** 小程序结构化消息场景的路径 */
export var structuredMessagePath = 'miniprogram/structured-message/';

/** 小程序结构化封面的路径 */
export var structuredCoverPath = 'miniprogram/structured-cover/';

/** 小程序分享占位符的路径 */
export var sharePlaceholderPath = 'miniprogram/share-placeholder/';

// 缩略图 padding 占盒子的百分比（与设计讨论过）
export var PADDING_PERCENT = 0.125;

// 缩略图圆角
export var THUMBNAIL_BORDER_PERCENT = 0.06;
//# sourceMappingURL=const.js.map